import { render, staticRenderFns } from "./ssoredirect.vue?vue&type=template&id=21c62e94&scoped=true&"
import script from "./ssoredirect.vue?vue&type=script&lang=js&"
export * from "./ssoredirect.vue?vue&type=script&lang=js&"
import style0 from "./ssoredirect.vue?vue&type=style&index=0&id=21c62e94&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c62e94",
  null
  
)

export default component.exports